import { type ButtonVariants, Icon, SlimButton } from 'components'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

const ICON_SIZE = '16'

export type AlertVariants = 'success' | 'warning' | 'error' | 'info'
export interface AlertProps {
  kind: AlertVariants
  title: string
  message?: string | React.ReactNode
  messageOrientation?: 'right' | 'bottom'
  actionLabel?: string
  actionIcon?: React.ReactNode
  handleAction?: () => void
  fullWidth?: boolean
}

export const Alert: React.FC<AlertProps> = ({
  kind,
  title,
  message,
  messageOrientation = 'bottom',
  actionLabel,
  actionIcon,
  handleAction,
  fullWidth = false,
}) => {
  const getIcon = () => {
    switch (kind) {
      case 'success':
        return <Icon color={theme.colors.alert.success.dark} icon="task-alt" size={ICON_SIZE} />
      case 'warning':
        return <Icon color={theme.colors.alert.warning.dark} icon="report" size={ICON_SIZE} />
      case 'error':
        return <Icon color={theme.colors.alert.danger.dark} icon="cancel" size={ICON_SIZE} />
      case 'info':
        return <Icon color={theme.colors.alert['info'].dark} icon="info" size={ICON_SIZE} />
    }
  }

  const buttonVariant: { [key in AlertVariants]: ButtonVariants } = {
    error: 'danger',
    info: 'primary',
    success: 'success',
    warning: 'warning',
  }

  return (
    <S.Container fullWidth={fullWidth} kind={kind}>
      <S.Texts>
        <S.TitleRow>
          <S.IconContainer>{getIcon()}</S.IconContainer>
          <strong>{title}</strong>
          {message && messageOrientation === 'right' && <span>{message}</span>}
        </S.TitleRow>
        {message && messageOrientation === 'bottom' && <span>{message}</span>}
      </S.Texts>
      {actionLabel && (
        <SlimButton
          content={actionLabel}
          icon={actionIcon}
          onClick={handleAction}
          variant={buttonVariant[kind]}
        />
      )}
    </S.Container>
  )
}
